module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/referralconfig/referralconfig.component.css
// module id = ./src/app/referralconfig/referralconfig.component.css
// module chunks = main